import React, { useState } from 'react';
import {
  SpeakerWaveIcon,
  ChevronDownIcon,
  ChevronUpIcon
} from '@heroicons/react/24/outline';
import { useTheme } from '../../contexts/ThemeContext';

const VoiceDemo: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { actualTheme } = useTheme();

  return (
    <div className={`${actualTheme === 'dark' ? 'bg-slate-800' : 'bg-white'} border-t ${actualTheme === 'dark' ? 'border-slate-700' : 'border-neutral-200'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Compact Header - Always Visible */}
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className={`w-full py-4 flex items-center justify-between transition-colors duration-200 ${actualTheme === 'dark'
              ? 'hover:bg-slate-700/50'
              : 'hover:bg-neutral-50'
            }`}
        >
          <div className="flex items-center">
            <SpeakerWaveIcon className={`h-6 w-6 mr-3 ${actualTheme === 'dark' ? 'text-slate-400' : 'text-primary-600'}`} />
            <div className="text-left">
              <h3 className={`text-lg font-semibold ${actualTheme === 'dark' ? 'text-slate-200' : 'text-primary-900'}`}>
                AI Voice Assistant
              </h3>
              <p className={`text-sm ${actualTheme === 'dark' ? 'text-slate-400' : 'text-neutral-600'}`}>
                24/7 multilingual support powered by Vapi.ai
              </p>
            </div>
          </div>
          {isExpanded ? (
            <ChevronUpIcon className={`h-5 w-5 ${actualTheme === 'dark' ? 'text-slate-400' : 'text-neutral-600'}`} />
          ) : (
            <ChevronDownIcon className={`h-5 w-5 ${actualTheme === 'dark' ? 'text-slate-400' : 'text-neutral-600'}`} />
          )}
        </button>

        {/* Expanded Content */}
        {isExpanded && (
          <div className="pb-6 animate-fade-in">
            <p className={`text-sm mb-4 ${actualTheme === 'dark' ? 'text-slate-400' : 'text-neutral-600'}`}>
              Experience natural, human-like conversations for bookings, inquiries, and support in 100+ languages.
            </p>
            <a
              href="https://vapi.ai/"
              target="_blank"
              rel="noopener noreferrer"
              className={`inline-flex items-center text-sm font-medium ${actualTheme === 'dark'
                  ? 'text-slate-300 hover:text-slate-200'
                  : 'text-primary-600 hover:text-primary-700'
                }`}
            >
              Learn more about Vapi.ai →
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default VoiceDemo;
